import React from "react";

const data: { [key: string]: any } = {
    '0.8': {
        correlation: 0.8,
        referenceScores: [3, 3.5, 4, 4.5, 5, 5.5, 6, 6, 7, 7, 7, 8, 8.5],
        sampleScores: [5, 3.5, 3, 3.5, 4, 4.5, 5, 4.5, 6, 8.5, 6, 8, 6]
    },
    '0.9': {
        correlation: 0.9,
        referenceScores: [3, 3.5, 4, 4.5, 5, 5.5, 6, 6, 7, 7, 7, 8, 8.5],
        sampleScores: [4, 4, 4, 4.5, 5.5, 6.5, 7, 5.5, 6, 7, 7, 8, 7,]
    },
    '0.5': {
        correlation: 0.5,
        referenceScores: [3, 3.5, 4, 4.5, 5, 5.5, 6, 6, 7, 7, 7, 8, 8.5],
        sampleScores: [3.5, 3, 5.5, 5, 6, 4, 4, 7.5, 8.5, 7, 6.5, 7.5, 3.5],
    }
}

function ResultsTable({ correlation }: { correlation: string }) {
    const allData = [
        data[correlation],
    ];

    return (
        <div className="flex flex-col max-w-100 overflow-x-auto">
            {allData.map((item, index) => (
                <div key={index} className="my-4">
                    <h3 className="text-lg font-bold mb-2">Correlation: {item.correlation}</h3>
                    <div className="overflow-x-scroll">
                        <table className="table-auto min-w-full">
                            <thead>
                                <tr>
                                    <th className="border px-2 sm:px-4 py-2">Reference Scores</th>
                                    {item.referenceScores.map((score: number, idx: number) => (
                                        <th key={idx} className="border px-2 sm:px-4 py-2">{score}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className="border px-2 sm:px-4 py-2">Sample Examiner Scores</td>
                                    {item.sampleScores.map((score: number, idx: number) => (
                                        <td key={idx} className="border px-2 sm:px-4 py-2">{score}</td>
                                    ))}
                                </tr>
                                <tr>
                                    <td className="border px-2 sm:px-4 py-2">Difference</td>
                                    {item.referenceScores.map((refScore: number, idx: number) => {
                                        const difference = Math.abs(refScore - item.sampleScores[idx]);
                                        return (
                                            <td
                                                key={idx}
                                                className={`border px-2 sm:px-4 py-2 ${difference <= 0.5 ? 'text-green-500' : 'text-yellow-500'}`}
                                            >
                                                {difference.toFixed(1)}
                                            </td>
                                        );
                                    })}
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            ))}
        </div>
    );
}

export default ResultsTable;